import { render, staticRenderFns } from "./ScholarshipDashboard.vue?vue&type=template&id=9aceb1e8&scoped=true"
import script from "./ScholarshipDashboard.vue?vue&type=script&lang=js"
export * from "./ScholarshipDashboard.vue?vue&type=script&lang=js"
import style0 from "./ScholarshipDashboard.vue?vue&type=style&index=0&id=9aceb1e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aceb1e8",
  null
  
)

export default component.exports